<div class="modal-notification">
    <header class="modal-notification__header">
        <h2 class="modal-notification__title">{{ titleForColor() }}</h2>
        <button
            type="button"
            class="modal-notification__close"
            aria-label="Cerrar"
            (click)="close(true)"
        >
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="modal-notification__body">
        @switch (color()) { @case ('success') {
        <mat-icon
            class="modal-notification__icon"
            [ngClass]="iconClass() || 'modal-notification__icon--success'"
            >check_circle</mat-icon
        >
        } @case ('info') {
        <mat-icon
            class="modal-notification__icon"
            [ngClass]="iconClass() || 'modal-notification__icon--info'"
            >info</mat-icon
        >
        } @case ('warning') {
        <mat-icon
            class="modal-notification__icon"
            [ngClass]="iconClass() || 'modal-notification__icon--warning'"
            >report_problem</mat-icon
        >
        } @case ('error') {
        <mat-icon
            class="modal-notification__icon"
            [ngClass]="iconClass() || 'modal-notification__icon--error'"
            >highlight_off</mat-icon
        >
        } }

        <p class="modal-notification__message">{{ message() }}</p>

        @for (item of multiline(); track $index) {
        <p class="modal-notification__multiline">{{ item }}</p>
        }
    </div>

    <div class="modal-notification__actions">
        <button
            mat-flat-button
            color="primary"
            type="button"
            class="modal-notification__ok"
            (click)="close(true)"
        >
            OK
        </button>
    </div>
</div>
